import Header from '../components/header/header'
import { HeroSection } from '../components/hero-section/hero-section'
import { AuraCore } from '../components/aura-core/aura-core'
import { WhyRecrutersChoose } from '../components/why-recruters-choose/why-recruters-choose'
import { CandidateOwnership } from '../components/candidate-ownership/candidate-ownership'
import { ProofImpact } from '../components/proof-impact/proof-impact'
import { HowItWork } from '../components/how-it-work/how-it-work'
import CTASection from '../components/cta-section/cta-section'
import Footer from '../components/footer/footer'

export const Home = () => {
    return (
        <div className='bg-[#000f2c]'>
            <div style={{ backgroundImage: `url('/hero_background.svg')` }}
                className="relative bg-cover bg-no-repeat bg-center w-full h-[120vh]">
                <Header />
                <HeroSection />
            </div>
            <AuraCore />
            <WhyRecrutersChoose />
            <CandidateOwnership />
            <ProofImpact />
            <HowItWork />
            <CTASection />
            <Footer />
        </div>
    )
}
